import Common from "../../common";
import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";

export const shetabFinalMixin = {
  data() {
    return {
      bankGateAway: "",
      timestamp: "",
      paymentId: "",
    };
  },
  computed: {
    ...mapGetters([
      "getPaymentSuccess",
      "getShetabSelectedPayingAmount",
      "getPaymentMethod",
      "getRefNumber",
      "getCallBackUrl",
      "getTransactionCompleteTime",
      "getVersion",
    ]),
  },
  methods: {
    ...mapMutations(["setStepperPage"]),
    // cancel() {
    //   if (this.getVersion === "v1") {
    //     alertHelper.loadingAlert();
    //     this.$http.delete(`payments/${this.paymentId}`).then(
    //       (result) => {
    //         window.location.href = Common.createCallback(
    //           result.data.data.callback_url,
    //           this.paymentId,
    //           0
    //         );
    //       },
    //       (error) => {
    //         alertHelper.apiErrorAlert("", error.body.message);
    //       }
    //     );
    //   }
    // },
    tryAgain() {
      const querySecret = this.$route.query.s;
      this.$router.push(`/?id=${this.paymentId}&s=${querySecret}`);
    },
    translatePaymentMethod() {
      switch (this.getPaymentMethod) {
        case "auto":
          this.bankGateAway = "اتوماتیک";
          break;
        case "melli":
          this.bankGateAway = "ملی";
          break;
        case "mellat":
          this.bankGateAway = "ملت";
          break;
        case "ayandeh":
          this.bankGateAway = "آینده";
          break;
        default:
          this.bankGateAway = "اتوماتیک";
          break;
      }
    },
    goToCallBackUrl() {
      if (this.getVersion === "v1")
        window.location.href = Common.createCallback(
          this.getCallBackUrl,
          this.paymentId,
          1
        );
      else if (this.getVersion === "v2") {
        alertHelper.transactionSuccessAlert(
          "پرداخت موفق",
          "حساب کاربری شما تا لحظاتی دیگر شارژ میشود",
          10000
        );
      }
    },
    autoGoToCallBackUrl() {
      if (this.getPaymentSuccess) {
        setTimeout(this.goToCallBackUrl, 500);
      }
    },
    msToTime(duration) {
      let seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      return hours + ":" + minutes + ":" + seconds;
    },
    getNow() {
      const today = new Date();
      const date =
        today.getFullYear() +
        "/" +
        (today.getMonth() + 1) +
        "/" +
        today.getDate();
      const time = this.msToTime(this.getTransactionCompleteTime);
      this.timestamp = time + " - " + date;
    },
  },
  created() {
    this.setStepperPage("pageFour");
    this.getNow();
    this.translatePaymentMethod();
    this.paymentId = this.$route.query.id;
    this.autoGoToCallBackUrl();
  },
};
